import React, {Component} from "react";
import { observer } from "mobx-react";

@observer
class OrderSearchNoDataView extends Component {
    render() {

        const { rootStore } = this.props;

        return (
            <div className="layer_comm layer_search layer_open">
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_search">
                        <div className="section_search_content_none">
                            {
                                rootStore.searchStore.getSearchNoDataVal==="SEARCH"
                                ?
                                <>
                                    <h1>검색어를 입력해주세요.</h1>
                                    <p>완료/취소 주문건은 [지난 주문내역]에서 조회 가능합니다. </p>
                                </>
                                :
                                <>
                                    <h1>검색 결과가 없습니다.</h1>
                                    <p>완료/취소 주문건은 [지난 주문내역]에서 조회 가능합니다. </p>
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderSearchNoDataView;